import { BASES, CATALOGUE_YEARS, TERRITORIES, TOP_N_OPTIONS } from '@dashboard/contract';
import { territoryName } from '../lib/format';
import type { Search } from '../state/search';

export function SelectorsCard({
  search,
  hasUs,
  anchorYear,
  onChange,
}: {
  search: Search;
  hasUs: boolean;
  anchorYear: number;
  onChange: (patch: Partial<Search>) => void;
}) {
  return (
    <div className="card inputs">
      <div className="field">
        <label htmlFor="f-topn">Top N Songs</label>
        <select
          id="f-topn"
          value={search.topN}
          onChange={(e) => onChange({ topN: Number(e.target.value) as Search['topN'] })}
        >
          {TOP_N_OPTIONS.map((n) => (
            <option key={n} value={n}>
              {n}
            </option>
          ))}
        </select>
        <div className="hint">Pick # songs broken down</div>
      </div>
      <div className="field">
        <label htmlFor="f-terr">Territory</label>
        <select
          id="f-terr"
          value={search.territory}
          onChange={(e) => onChange({ territory: e.target.value as Search['territory'] })}
        >
          {TERRITORIES.map((t) => (
            <option key={t} value={t} disabled={t !== 'WW' && !hasUs}>
              {territoryName(t)}
              {t !== 'WW' && !hasUs ? ' — not ingested' : ''}
            </option>
          ))}
        </select>
        <div className="hint">Pick between: Worldwide, US, Ex-US</div>
      </div>
      <div className="field">
        <label htmlFor="f-cat">Catalogue Year</label>
        <select
          id="f-cat"
          value={search.cat}
          onChange={(e) => onChange({ cat: Number(e.target.value) as Search['cat'] })}
        >
          {CATALOGUE_YEARS.map((y) => (
            <option key={y} value={y}>
              {y}
            </option>
          ))}
        </select>
        <div className="hint">Breaks down songs based on that year. Pick between: 2016–2022</div>
      </div>
      <div className="field">
        <label htmlFor="f-basis">Total basis</label>
        <select
          id="f-basis"
          value={search.basis}
          onChange={(e) => onChange({ basis: e.target.value as Search['basis'] })}
        >
          {BASES.map((b) => (
            <option key={b} value={b}>
              {b === 'YTD21' ? `2021-${anchorYear}YTD` : b}
            </option>
          ))}
        </select>
        <div className="hint">Universe to pick Top N Songs and % Total</div>
      </div>
    </div>
  );
}
